import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Header */}
      <section className="py-16 px-6 md:px-12 lg:px-24 border-b bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-semibold text-[#0f3e3e] mb-4">
            Terms & Conditions
          </h1>
          <p className="text-muted-foreground">
            These Terms and Conditions govern the use of the website and services
            provided by Safety Training Institute.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 px-6 md:px-12 lg:px-24">
        <div className="max-w-4xl mx-auto space-y-8 text-muted-foreground leading-relaxed">

          <p>
            By accessing this website or enrolling in any course offered by
            Safety Training Institute, you agree to comply with and be bound by
            the following Terms & Conditions.
          </p>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              1. Eligibility
            </h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>Users must provide accurate and complete information during registration.</li>
              <li>Minimum eligibility criteria may apply for certain courses.</li>
              <li>Admission is subject to verification of documents.</li>
            </ul>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              2. Course Enrollment
            </h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>Enrollment is confirmed only after successful payment.</li>
              <li>Course details, duration, and fees are mentioned on the website or prospectus.</li>
              <li>Safety Training Institute reserves the right to modify course content or schedule.</li>
            </ul>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              3. Fees & Payments
            </h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>All fees must be paid in full before course access is granted.</li>
              <li>
                Fees once paid are non-refundable, except as mentioned in the
                Cancellation & Refund Policy.
              </li>
              <li>Payment gateway charges, if any, are borne by the student.</li>
            </ul>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              4. Online Courses & Access
            </h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>Login credentials are for individual use only and must not be shared.</li>
              <li>Unauthorized sharing of course content is strictly prohibited.</li>
              <li>Access may be suspended in case of misuse or violation.</li>
            </ul>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              5. Certificate Policy
            </h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>
                Certificates are issued only after successful course completion,
                assessments, and verification of student details.
              </li>
              <li>Certificates may be provided in digital or physical format.</li>
              <li>
                Once issued, certificates cannot be cancelled or modified except
                for genuine errors.
              </li>
              <li>
                Certificate verification may be available through QR code or an
                online portal.
              </li>
            </ul>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              6. Student Conduct
            </h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>Students must follow institute rules, safety guidelines, and discipline.</li>
              <li>Misconduct may lead to suspension or cancellation of enrollment.</li>
              <li>No refund will be applicable in such cases.</li>
            </ul>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              7. Intellectual Property
            </h2>
            <p>
              All content including text, videos, logos, and training materials
              are the intellectual property of Safety Training Institute.
            </p>
            <p>
              Reproduction or redistribution without prior permission is
              prohibited.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              8. Limitation of Liability
            </h2>
            <p>
              Safety Training Institute shall not be held responsible for any
              direct or indirect loss, injury, or damages arising from the use of
              our training programs or website.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              9. Third-Party Services
            </h2>
            <p>
              Our website may include third-party links or payment gateways. We
              are not responsible for their terms, policies, or services.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              10. Termination
            </h2>
            <p>
              The institute reserves the right to terminate access or enrollment
              without prior notice in case of policy violations.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              11. Governing Law
            </h2>
            <p>
              These Terms & Conditions shall be governed by the laws of India.
              Any disputes shall be subject to the jurisdiction of Odisha courts.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              12. Changes to Terms
            </h2>
            <p>
              Safety Training Institute may update these Terms & Conditions at
              any time. Continued use of the website implies acceptance of the
              updated terms.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              13. Contact Information
            </h2>
            <p><strong>Institute Name:</strong> Safety Training Institute</p>
            <p><strong>Location:</strong> Bahanaga, Balasore, Odisha – 756042</p>
            <p><strong>Phone:</strong> 8280607556 / 9938232920</p>
            <p>
              <strong>Email:</strong>{" "}
              <a
                href="mailto:info@safetytraininginstitute.org.in"
                className="text-[#0f3e3e] font-medium"
              >
                info@safetytraininginstitute.org.in
              </a>
            </p>
            <p>
              <strong>Website:</strong>{" "}
              <a
                href="https://www.safetytraininginstitute.org.in"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#0f3e3e] font-medium"
              >
                www.safetytraininginstitute.org.in
              </a>
            </p>
          </div>

        </div>
      </section>
      <Footer/>
    </div>
  );
};

export default TermsAndConditions;